export enum SyncStatus {
    Pending,
    Succeeded,
    PartiallySucceeded,
    Retry,
    Failed,
    Cancelled
}